<template>
  <div></div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  mounted() {
    this.$router.push({
      path: this.$route.query.path
    })
  }
})
</script>
